"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryToFormatPhoneNumber = void 0;
const digitsInValidPhoneNumber = 10;
function tryToFormatPhoneNumber(phone) {
    if ((phone === null || phone === void 0 ? void 0 : phone.length) !== digitsInValidPhoneNumber) {
        return phone;
    }
    const result = `+1 (${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
    return result;
}
exports.tryToFormatPhoneNumber = tryToFormatPhoneNumber;
